import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUtilityReadings,
  getUtilityReadingById,
  inputUtilityReading,
  inputUtilityReadingBatch,
  previewUtilityInvoice,
  generateUtilityInvoice,
  calculateElectricityPreview,
  calculateWaterPreview,
  verifyUtilityReading,
} from "libs/api/utility_reading";

function makeThunk(typePrefix, apiFn, argMapper) {
  return createAsyncThunk(typePrefix, async (args) => {
    const { cbPending, cbFulfilled, cbRejected, cbFinally, ...rest } = args;
    try {
      typeof cbPending === "function" && cbPending();
      const response = await apiFn(...(argMapper ? argMapper(rest) : [rest]));
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      }
      typeof cbRejected === "function" && cbRejected(error);
      throw JSON.stringify({ message: error.message });
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  });
}

export const getUtilityReadingsThunk = makeThunk(
  "utilityReading/get",
  getUtilityReadings,
  ({ queryParams = "" }) => [queryParams],
);

export const getUtilityReadingByIdThunk = makeThunk(
  "utilityReading/getById",
  getUtilityReadingById,
  ({ id, utilityType }) => [id, utilityType],
);

export const inputUtilityReadingThunk = makeThunk(
  "utilityReading/input",
  inputUtilityReading,
  ({ body }) => [body],
);

export const inputUtilityReadingBatchThunk = makeThunk(
  "utilityReading/inputBatch",
  inputUtilityReadingBatch,
  ({ body }) => [body],
);

export const previewUtilityInvoiceThunk = makeThunk(
  "utilityReading/preview",
  previewUtilityInvoice,
  ({ queryParams = "" }) => [queryParams],
);

export const generateUtilityInvoiceThunk = makeThunk(
  "utilityReading/generate",
  generateUtilityInvoice,
  ({ body }) => [body],
);

export const calculateElectricityPreviewThunk = makeThunk(
  "utilityReading/calculatePreview",
  calculateElectricityPreview,
  ({ body }) => [body],
);

export const calculateWaterPreviewThunk = makeThunk(
  "utilityReading/calculateWaterPreview",
  calculateWaterPreview,
  ({ body }) => [body],
);

export const verifyUtilityReadingThunk = makeThunk(
  "utilityReading/verify",
  verifyUtilityReading,
  ({ id, body }) => [id, body],
);
